import React from 'react';
import Loadable from 'react-loadable';
import { WebformProps } from './types';

/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
const Webform: React.FC<WebformProps> = Loadable({
  loader: () => import('./index.lazy'),
  loading: () => (<div />),
});

export default Webform;
